import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

// Initialize theme from localStorage or system preference
try {
	const savedTheme = localStorage.getItem('theme');
	const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
	const useDark = savedTheme ? savedTheme === 'dark' : prefersDark;
	const rootEl = document.documentElement;
	if (useDark) {
		rootEl.classList.add('dark');
	} else {
		rootEl.classList.remove('dark');
	}
} catch {}

root.render(<App />);
